import { Upload } from "../services/generated-sdk";
import Storage from "browserstorage-ttl";
import { getLocationForCurrentSession } from "./data-residency";

export const getAvatarURL = (avatar: Upload) => {
  if (!avatar) return null;
  let url;
  //console.log({ avatar });
  if (avatar.provider == "mock") {
    url = avatar.url;
  } else {
    let location = getLocationForCurrentSession();
    url =
      avatar.provider === "local"
        ? process.env["API_BASE_URL"] + "/" + avatar.url
        : avatar.url;
    if (location == "EU") {
      url =
        avatar.provider === "local"
          ? process.env["API_BASE_URL_EU"] + "/" + avatar.url
          : avatar.url;
    }
  }
  return url;
};

export const storeUserSession = (user, expiry) => {
  Storage.set("TC_USER", JSON.stringify(user), expiry);
};

const SESSION_TTL_MINUTES = 14 * 24 * 60; // 14 days

/**
 * If the session lives in localStorage (i.e. "Remember Me" was used),
 * re-store it with a fresh 14-day TTL so it doesn't expire while
 * the user is actively using the app.
 */
export const refreshSessionTTL = () => {
  try {
    const raw = localStorage.getItem("TC_USER");
    if (!raw) return; // session-only (no Remember Me) — nothing to refresh
    const parsed = JSON.parse(raw);
    if (parsed && parsed.value && parsed.timestamp) {
      parsed.timestamp = Date.now() + SESSION_TTL_MINUTES * 60 * 1000;
      localStorage.setItem("TC_USER", JSON.stringify(parsed));
    }
  } catch (e) {
    // ignore — don't break the app over TTL refresh
  }
};
